import { render, staticRenderFns } from "./ChatCountChart.vue?vue&type=template&id=6d067a12&scoped=true"
import script from "./ChatCountChart.vue?vue&type=script&lang=js"
export * from "./ChatCountChart.vue?vue&type=script&lang=js"
import style0 from "./ChatCountChart.vue?vue&type=style&index=0&id=6d067a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d067a12",
  null
  
)

export default component.exports